import React, { useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownOverlay,
  AutoComplete,
  ActionList,
  ActionListItem,
  Box,
  Spinner,
  Text,
  SelectInputProps,
} from '@razorpay/blade/components';
import { useQuery } from 'react-query';
import api from 'api';
import { statesOfIndia } from 'utils/StatesOfIndia';

export const DispensaryDropdown = ({
  value,
  selectedStateCode,
  selectedDistrict,
  onChange,
}: {
  value: string;
  selectedStateCode: string;
  selectedDistrict: string;
  onChange: SelectInputProps['onChange'];
}) => {
  const [searchValue, setSearchValue] = useState('');
  const selectedState = statesOfIndia.find(
    (s) => s.code.toString() === selectedStateCode,
  )?.esicState;

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['dispensary', selectedState, selectedDistrict],
    queryFn: () =>
      api.officeLocation.fetchDispensaryForDistrict({
        state: selectedState!,
        district: selectedDistrict!,
      }),
    enabled: !!selectedState && !!selectedDistrict,
  });

  const filteredDispensaries =
    data?.filter((dispensary) =>
      searchValue ? dispensary.toLowerCase().includes(searchValue.toLowerCase()) : true,
    ) || [];

  useEffect(() => {
    setSearchValue(value || '');
  }, [value]);

  return (
    <Dropdown
      selectionType="single"
      onOpenChange={(isOpen) => {
        if (!isOpen && value) {
          setSearchValue(value);
        } else {
          setSearchValue('');
        }
      }}>
      <AutoComplete
        label="ESIC Dispensary"
        placeholder="Search ESIC Dispensary"
        name="dispensary"
        inputValue={searchValue || ''}
        onInputValueChange={({ value }) => {
          setSearchValue(value || '');
        }}
        filteredValues={filteredDispensaries}
        value={value}
        onChange={onChange}
      />
      <DropdownOverlay>
        {isLoading || isFetching ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="spacing.5"
            padding="spacing.5">
            <Spinner accessibilityLabel="loading states" />
          </Box>
        ) : filteredDispensaries?.length ? (
          <ActionList>
            {filteredDispensaries?.map((dispensary, idx) => (
              <ActionListItem
                key={idx + dispensary}
                title={dispensary}
                value={dispensary}
                isSelected={value === dispensary}
              />
            ))}
          </ActionList>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="spacing.5"
            padding="spacing.5">
            <Box display="flex" flexDirection="column" gap="spacing.3">
              <Text size="medium" weight="semibold" textAlign="center">
                No Dispensaries Found
              </Text>
            </Box>
          </Box>
        )}
      </DropdownOverlay>
    </Dropdown>
  );
};
